<template>
  <div class="page">
    <div v-if="list && list.length" class="box">
      <ul class="list">
        <li v-for="(item, index) in list" :key="index" class="list-item">
          <div>
            <div class="list-item__title flex">
              <div class="title van-ellipsis">{{ item.customerName }}</div>
              <div class="status">
                <span :style="{ color: getStatusColor(item) }">{{
                  item.status
                }}</span>
              </div>
            </div>
            <div class="list-item__text flex">
              <div class="text">客户需求：</div>
              <div class="text">
                {{ item.customerDemand ? item.customerDemand.join(",") : "" }}
              </div>
            </div>
            <div class="list-item__text flex">
              <div class="text">客户联系人：</div>
              <div class="text">
                {{ item.customerPerson }} {{ item.customerPhone }}
              </div>
            </div>
          </div>
          <div class="list-item__footer van-hairline--top">
            <span>{{ item.createdate }}</span>
          </div>
        </li>
      </ul>
    </div>
    <Empty v-else description="暂无数据" />
  </div>
</template>

<script>
import { List, Cell, Toast, Icon, Empty } from "vant";
import { get } from "@/utils/request";
import { api } from "@/utils/env";

export default {
  components: {
    List,
    Cell,
    Icon,
    Empty,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      detail: {},
    };
  },
  computed: {},
  mounted() {
    this.getList();
  },
  methods: {
    getStatusColor(row) {
      const statusList = [
        {
          label: "待售前处理",
          value: "待售前处理",
          color: "#fb4529",
        },
        {
          label: "已成交",
          value: "已成交",
          color: "#47CC76",
        },
        {
          label: "已作废",
          value: "已作废",
          color: "#948E8E",
        },
      ];
      const item = statusList.find((item) => item.value === row.status);
      if (item) {
        return item.color;
      }
      return "";
    },
    getList() {
      get({
        url: api + "/thirdBusinessOp/list",
        data: {},
        requestType: 1,
      })
        .then((data) => {
          if (data.result === "success") {
            this.list = data.body || [];
          } else {
            Toast(data.message);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  box-sizing: border-box;
  min-height: 100vh;
  padding-top: 0.16rem;
  padding-bottom: 1.92rem;
  background: #f5f5f5;
}

.flex {
  display: flex;
  align-items: center;

  &-space {
    flex: 1;
  }
}

.list {
  &-item {
    box-sizing: border-box;
    width: 7.1rem;
    padding: 0.16rem 0.3rem 0;
    background: #ffffff;
    border-radius: 0.16rem;
    margin: 0 auto 0.16rem;
    overflow: hidden;

    &__title {
      box-sizing: border-box;
      padding: 0.12rem 0 0.16rem;
      margin-bottom: 0.16rem;

      .title {
        flex: 1;
        font-size: 0.28rem;
        font-weight: 500;
        color: #353232;
        line-height: 0.28rem;
      }

      .status {
        flex: 1;
        text-align: right;
        font-size: 0.28rem;
        font-weight: 400;
        line-height: 0.28rem;
      }
    }

    &__text {
      margin-bottom: 0.16rem;
      font-size: 0.24rem;
      font-weight: 400;
      color: #595353;
      line-height: 0.28rem;

      .text {
        padding-left: 0.1rem;
      }
    }

    &__footer {
      box-sizing: border-box;
      padding: 0.26rem 0;
      text-align: right;
      font-size: 0;

      span {
        font-size: 0.24rem;
        font-weight: 400;
        color: #595353;
        line-height: 0.24rem;
      }
    }
  }
}
</style>